import { Skeleton } from "@/components/ui/skeleton"

export function ReportListSkeleton() {
  return (
    <div className="flex flex-col gap-2 p-4">
      {/* Table header skeleton */}
      <div className="flex items-center gap-4 border-b pb-2">
        <Skeleton className="h-4 w-4" /> {/* Checkbox */}
        <Skeleton className="h-4 w-32" /> {/* Report column */}
        <Skeleton className="ml-auto h-4 w-48" /> {/* Parameter Summary column */}
      </div>

      {/* Table rows skeleton */}
      {Array.from({ length: 5 }).map((_, i) => (
        <div key={i} className="flex items-center gap-4 py-2">
          <Skeleton className="h-4 w-4" /> {/* Drag handle */}
          <Skeleton className="h-4 w-4" /> {/* Checkbox */}
          <Skeleton className="h-4 w-40" /> {/* Report name */}
          <div className="ml-auto flex gap-1">
            <Skeleton className="h-5 w-24 rounded-full" /> {/* Badge */}
            <Skeleton className="h-5 w-32 rounded-full" /> {/* Badge */}
          </div>
        </div>
      ))}
    </div>
  )
}
